(() => {
  function initialize(root = document) {
    if (!document.documentElement.classList.contains('jk-whatsapp-visit')) return;
    root.querySelectorAll('template[id^="WhatsappDesktopMenu-"]').forEach((template) => {
      const header = template.closest('header');
      if (!header || header.dataset.whatsappMenuReady) return;
      const mobile = header.querySelector('template[id^="WhatsappMobileMenu-"]');
      const desktopMenu = header.querySelector('kekka-nav-slider');
      const mobileGrid = header.querySelector('.drawer-menu-view .custom-header-grid');
      if (desktopMenu) desktopMenu.replaceWith(template.content.cloneNode(true));
      if (mobileGrid && mobile) mobileGrid.replaceWith(mobile.content.cloneNode(true));
      header.dataset.whatsappMenuReady = 'true';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
